<template>
  <!--header-->
  <div class="theBackgroundColorOfTheRegistration">
    <div class="header_registered">
      <div class="header_centent">
        <div class="header_left">
          <div class="header_logo">
            <a href="index.html">
              <img src="../assets/image/logo.png" />
            </a>
          </div>
        </div>
        <div class="header_rights">
          我已经注册，马上<span
            ><router-link to="/registered">登录</router-link> 》</span
          >
        </div>
      </div>
    </div>
    <!--header end-->
    <!--主体内容开始-->

    <div class="regi_srat">
      <div class="reai_left">
        <div class="message">
          注册信息
          <span class="registrationPrompt">
            注：辽宁省内教师和学生，请联系校内管理员创建账号。
          </span>
        </div>

        <el-form
          ref="ruleFormRef"
          :rules="rules"
          :model="theNewData"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="省份" prop="province">
            <div style="width: 100%">
              <el-select v-model="theNewData.province" placeholder="请选择省份">
                <el-option
                  v-for="item in options"
                  :key="item.districtName"
                  :label="item.districtName"
                  :value="item.districtName"
                  @click="theQuery(item.keyId)"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="城市" prop="city">
            <el-select v-model="theNewData.city" placeholder="请选择市">
              <el-option
                v-for="item in optionsr"
                :key="item.districtName"
                :label="item.districtName"
                :value="item.districtName"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="身份" prop="indexType">
            <el-select v-model="theNewData.indexType" placeholder="请选择身份">
              <el-option
                v-for="item in toObtainStatusData"
                :key="item.dictValue"
                :label="item.remark"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="单位名称" prop="school">
            <el-input
              v-model="theNewData.school"
              placeholder="请填写单位名称或学校名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="nickName">
            <el-input
              v-model="theNewData.nickName"
              placeholder="请填写姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="userName">
            <el-input
              v-model="theNewData.userName"
              placeholder="请填写用户名"
            ></el-input>
          </el-form-item>

          <el-form-item label="登录密码" prop="password">
            <el-input
              type="password"
              v-model="theNewData.password"
              placeholder="6-15位字母（区分大小写）、数字、符号"
              autocomplete="off"
              @input="passwordcomplex(theNewData.password)"
            ></el-input>
          </el-form-item>

          <div class="passwordStrengthTesting">
            <td id="level" class="pw-strength" :class="theIntensityOfRealtime">
              <div class="pw-bar"></div>
              <div class="pw-bar-on"></div>
              <div class="pw-txt">
                <span>弱</span>
                <span>中</span>
                <span>强</span>
              </div>
            </td>
          </div>

          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              type="password"
              v-model="theNewData.checkPass"
              autocomplete="off"
              placeholder="6-15位字母（区分大小写）、数字、符号"
              @change="enterThePassword(theNewData.checkPass)"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phonenumber">
            <el-input
              v-model="theNewData.phonenumber"
              placeholder="请填写手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <div class="codeys">
              <div class="codesleft">
                <el-input
                  v-model="theNewData.code"
                  placeholder="请填写手机验证码"
                ></el-input>
              </div>
              <el-button
                type="primary"
                @click="sendATextMessage()"
                :disabled="isDisabled"
                >{{ buttonName }}</el-button
              >
            </div>
          </el-form-item>

          <!-- <el-form-item label="活动时间" required>
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="ruleForm.date1"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker
                  placeholder="选择时间"
                  v-model="ruleForm.date2"
                  style="width: 100%"
                ></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="即时配送" prop="delivery">
            <el-switch v-model="ruleForm.delivery"></el-switch>
          </el-form-item>
          <el-form-item label="活动性质" prop="type">
            <el-checkbox-group v-model="ruleForm.type">
              <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
              <el-checkbox label="地推活动" name="type"></el-checkbox>
              <el-checkbox label="线下主题活动" name="type"></el-checkbox>
              <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="特殊资源" prop="resource">
            <el-radio-group v-model="ruleForm.resource">
              <el-radio label="线上品牌商赞助"></el-radio>
              <el-radio label="线下场地免费"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动形式" prop="desc">
            <el-input type="textarea" v-model="ruleForm.desc"></el-input>
          </el-form-item> -->
          <!-- <el-form-item>
         <el-button type="primary" @click="submitForm('ruleForm')"
              >立即创建</el-button
            >
            <el-button @click="resetForm('ruleForm')">重置</el-button>
       
          </el-form-item> -->

          <div class="regi_btn">
            <button type="button" @click="submitForm('ruleForm')">
              同意协议并注册
            </button>
          </div>
          <div class="regi_ts">
            <input type="checkbox" name="checkbox" checked="" id="check" />
            <div>
              我已阅读并同意<a target="_blank" href="Platformagreement.html"
                >服务条款</a
              >及<a target="_blank" href="Privacypolicy.html">隐私权政策</a>
            </div>
          </div>
        </el-form>
      </div>
      <div class="reai_right">
        <img src="../assets/image/registration_right.png" />
      </div>
    </div>
  </div>
  <!--主体内容结束-->
  <!--foot-->
</template>

<script>
import { ref, reactive } from "@vue/reactivity";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  registeredToSendMessages,
  registered,
  queryInterfaceProvince,
  cityOfQueryInterface,
  registrationStatusFor,
} from "../assets/api/index";
import router from "../router/index.js";
export default {
  setup() {
    const levelDisplay = ref(2);
    const ruleFormRef = ref(null);
    const rules = {
      // province: [{ required: true, message: "请选择省", trigger: "blur" }],
      // city: [{ required: true, message: "请选择市", trigger: "blur" }],
      indexType: [{ required: true, message: "请选择身份", trigger: "blur" }],
      school: [
        {
          required: true,
          message: "请填写单位名称或学校名称",
          trigger: "blur",
        },
      ],
      userName: [{ required: true, message: "请填写用户名", trigger: "blur" }],
      nickName: [{ required: true, message: "请填写姓名", trigger: "blur" }],
      password: [
        { required: true, message: "请输入密码", trigger: "blur" },
        {
          type: "string",
          message: "请输入不包含空格的字符",
          trigger: "blur",
          transform(value) {
            if (value && value.indexOf(" ") === -1) {
              return value;
            } else {
              return false;
            }
          },
        },
        {
          trigger: "blur",
          validator: (rule, value, callback) => {
            var passwordreg = /(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,15}/;
            if (!passwordreg.test(value)) {
              callback(
                new Error("密码必须由数字、字母、特殊字符组合,请输入6-15位")
              );
            } else {
              callback();
            }
          },
        },
      ],

      checkPass: [
        { required: true, message: "请输入确认密码", trigger: "blur" },
      ],

      phonenumber: [
        { required: true, message: "请填写手机号", trigger: "blur" },
      ],
      code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
    };

    const strengthGrade = ref(1);
    const props = ref();
    const options = ref();
    const optionsr = ref();
    const getData = () => {
      // const city = require("../assets/api/city.json");
      // console.log(city);

      queryInterfaceProvince().then((res) => {
        options.value = res.rows;
      });
    };
    getData();
    const cityInterfaceToSend = reactive({
      upid: "",
    });
    //查询市接口
    const theQuery = (value) => {
      cityInterfaceToSend.upid = value;

      cityOfQueryInterface(cityInterfaceToSend).then((res) => {
        optionsr.value = res.rows;
      });
      getData();
    };

    //注册身份获取
    const toObtainStatusData = ref();
    const identityFor = () => {
      registrationStatusFor().then((res) => {
        toObtainStatusData.value = res.index_type;
      });
    };
    identityFor();

    const ruleForm = ref({
      name: "",
      region: "",
      date1: "",
      date2: "",
      delivery: false,
      type: [],
      resource: "",
      desc: "",
    });
    const theNewData = reactive({
      school: "",
      // province: ["zhinan", "shejiyuanze", "yizhi"],
      province: "",
      city: "",
      nickName: "",
      indexType: "",
      userName: "",
      password: "",
      phonenumber: "",
      code: "",
    });
    //发送短信
    const CountDown = ref(120);
    const buttonName = ref("发送验证码");
    const isDisabled = ref(false);
    const sendATextMessage = () => {
      registeredToSendMessages(theNewData.phonenumber).then((res) => {
        var timer = setTimeout(fn, 1000); //定时
        function fn() {
          CountDown.value--;
          if (CountDown.value > 0) {
            buttonName.value = "请等待 " + CountDown.value + " 秒";
            setTimeout(fn, 1000);
            0;
            isDisabled.value = true;
          } else {
            buttonName.value = "重新获取";
            isDisabled.value = false;
          }
        }

        ElMessage.success("短信发送成功!");
      });
    };

    const submitForm = () => {
      ruleFormRef.value.validate((valid) => {
        if (valid) {
          registered(theNewData).then((res) => {
            if (res.code == 200) {
              router.push("registered");
              ElMessage.success(res.msg);
            } else {
              ElMessage.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    };

    const enterThePassword = (value) => {
      if (value == theNewData.password) {
      } else {
        theNewData.checkPass = "";
        ElMessage.error("两次密码输入不一致！");
      }
    };
    //输入密码
    const theIntensityOfRealtime = ref([""]);
    const passwordcomplex = (value) => {
      // pwdLen长度
      if (value.length > 1 && value.length <= 5) {
        //长度在4-7之间，加五分
        theIntensityOfRealtime.value = "pw-weak";
      } else if (value.length > 5) {
        //长度在7以上，加10分

        theIntensityOfRealtime.value = "pw-medium";
      } else {
        theIntensityOfRealtime.value = "";
        // theIntensityOfRealtime.value = "pw-strong";
      }

      console.log(value);
    };

    return {
      CountDown, //倒计时
      buttonName, //按钮初始化文字
      isDisabled, //是否禁用按钮
      passwordcomplex,
      theIntensityOfRealtime,
      cascadeBinding: [],
      props,
      ruleForm,
      rules,
      theNewData,
      options,
      optionsr,
      toObtainStatusData,
      strengthGrade,
      ruleFormRef,
      enterThePassword,
      identityFor,
      theQuery,
      cityInterfaceToSend,
      sendATextMessage,
      submitForm,
      getData,
      levelDisplay,
    };
  },

  name: "mylogin",
};
</script>

<style src="../assets/css/registration.css" scoped></style>
<style scoped>
#app {
  width: 100%;
  background: #eee;
}
.theBackgroundColorOfTheRegistration {
}
.el-form.demo-ruleForm {
  margin-top: 23px;
}

.codeys {
  display: flex;
}
.codesleft {
  width: 100%;
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}

/*密码强度*/
.pw-strength {
  clear: both;
  position: relative;
  top: -6px;
  width: 180px;
  left: 98px !important;
}
.pw-bar {
  background: url("../assets/image/pwd-1.png") no-repeat;
  height: 14px;
  overflow: hidden;
  width: 179px;
}

.pw-bar-on {
  background: url("../assets/image/pwd-2.png") no-repeat;
  width: 0px;
  height: 14px;
  position: absolute;
  top: 0 !important;
  left: 2px;
  transition: width 0.5s ease-in;
  -moz-transition: width 0.5s ease-in;
  -webkit-transition: width 0.5s ease-in;
  -o-transition: width 0.5s ease-in;
}
.pw-weak .pw-defule {
  width: 0px;
}
.pw-weak .pw-bar-on {
  width: 60px;
}
.pw-medium .pw-bar-on {
  width: 120px;
}
.pw-strong .pw-bar-on {
  width: 179px;
}
.pw-txt {
  padding-top: 2px;
  width: 180px;
  overflow: hidden;
}
.pw-txt span {
  color: #707070;
  float: left;
  font-size: 12px;
  text-align: center;
  width: 58px;
}
</style>